import { mockSceStatus } from "../sce";
import { getMockTagStatus } from "../tag";
import { mockUser } from "../user";
import {
  CtoStepEnum,
  CreationTypeEnum,
  CtoGrid,
  Cto,
} from "../../../types/cto/ctoTypes";
import { ResponsePostCto } from "../../../types/cto/step0";
import { CtoStatus } from "../../../types/statusTypes";

export const mockCtoCode = "CTO-0000";

export const mockResponsePostCto = (
  cto_code = mockCtoCode,
  current_step: CtoStepEnum = 1,
): ResponsePostCto => ({
  cto_code,
  current_step,
});

export const mockCto: Cto = {
  status: CtoStatus.LIVE,
  cto_code: "CTO123",
  cto_id: "CTO123-ID",
  merge_status: null,
  sces: [mockSceStatus],
  tags: [getMockTagStatus()],
  created_at: new Date(),
  created_by: mockUser,
  current_step: 8,
  creation_type: CreationTypeEnum.AUTO,
  final_date: new Date("2024-01-09"),
  versions: [],
  manual_close: null,
  cto_summary: "CTO Summary",
  cto_title: "CTO Title",
  tag_reason: undefined,
  cto_type: "COMMON",
  deferment: null,
};

export const mockCtoGrid: CtoGrid = {
  ...mockCto,
  finalDate: mockCto.final_date ?? undefined,
  cto_id: mockCto.cto_id ?? mockCto.cto_code,
  merge_status: mockCto.merge_status ?? null,
  sces: [mockSceStatus.sce_code],
  tags: [getMockTagStatus().tag_code],
  machine_version: 2,
};
